import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { Subject } from 'rxjs';

@Component({
  selector: 'app-render-list-item',
  templateUrl: './render-list-item.component.html',
  styleUrls: ['./render-list-item.component.scss']
})
export class RenderListItemComponent implements OnInit,OnDestroy {
 @Input() item;
 @Input() backendListRender;
 private destroy$ = new Subject<void>();
 
  constructor(private router:Router) { }

  ngOnInit(): void {
  }

  redirect(){
    this.router.navigate(['/analytics/settlement/detail', this.item.settlementId]);
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.unsubscribe();
  }

}
